module.exports = __webpack_public_path__ + "static/media/tour.49ce5373.png";